import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  SFDatagrid,
  SFActionBar,
  SFPageContainer,
  ACTION_BAR_ACTION_TYPES,
  ACTION_BAR_ACTION_NAMES,
} from "@sf-core";
import { PATHS } from "../../constants/paths";
import getNavDefs from "../navDefs/getSkillsExtractionNavDefs";
import { useSelector } from "react-redux";
import { API_PARAM } from "../../constants/apiParams";
import { GridNames } from "../../constants/gridConfig";
import {
  exportPrimaryTextGrid,
  uploadFromPrimaryText,
} from "../../services/primaryTextService";
import { Claims } from "../../constants/claims";

const PrimaryText = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const navDefs = getNavDefs({ t });

  const primaryTextGridLayout = useSelector((state) =>
    state.gridLayout.find((grid) => grid.gridName === GridNames.PRIMARY_TEXT)
  );

  const handlePrimaryTextDownload = () => {
    exportPrimaryTextGrid(primaryTextGridLayout?.filterModel ?? {});
  };

  const columnDefs = useMemo(
    () => [
      {
        headerName: t("primaryTextScreen.primaryTextGrid.microSkillIdColumn"),
        field: "microSkillId",
        hide: false,
      },
      {
        headerName: t("primaryTextScreen.primaryTextGrid.microSkillNameColumn"),
        field: "microSkillName",
        filter: true,
        filterParams: {
          order: 1,
        },
      },
      {
        headerName: t("primaryTextScreen.primaryTextGrid.primaryTextColumn"),
        field: "primaryText",
        filter: true,
        filterParams: {
          order: 2,
        },
      },
    ],
    []
  );

  const actionDefs = [
    {
      name: ACTION_BAR_ACTION_NAMES.ADD,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      permissions: [Claims.AdminDataSkillExtractionImport],
      onClick: () => navigate(PATHS.PRIMARY_TEXT_PATH_ADD),
      buttonProps: {
        label: t("manageSkillsExtractionScreen.addPrimaryTextBtn"),
        variant: "primary",
      },
    },
    {
      name: ACTION_BAR_ACTION_NAMES.DOWNLOAD,
      type: ACTION_BAR_ACTION_TYPES.ICON,
      permissions: [Claims.AdminDataSkillExtractionExport],
      onClick: handlePrimaryTextDownload,
      iconProps: {
        tooltip: t("analyticsSkillExtractionRoutes.download.primaryText"),
        overflowLabel: t("analyticsSkillExtractionRoutes.download.primaryText"),
      },
    },
    {
      name: "submitPrimaryText",
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      permissions: [Claims.AdminDataSkillExtractionUpload],
      onClick: uploadFromPrimaryText,
      buttonProps: {
        label: t("analyticsSkillExtractionRoutes.submitButtonLabel"),
        variant: "primary",
        async: true,
      },
      confirmation: true,
      confirmationProps: {
        message: t("benchmark.submitDictionaryButton.submitMessage"),
        header: t("benchmark.submitDictionaryButton.submitHeader"),
        primaryLabel: t("benchmark.submitDictionaryButton.submitConfirm"),
        secondaryLabel: t("benchmark.submitDictionaryButton.submitCancel"),
      },
    },
    {
      name: ACTION_BAR_ACTION_NAMES.FILTER,
      type: ACTION_BAR_ACTION_TYPES.ICON,
      filterParams: {
        gridName: GridNames.PRIMARY_TEXT,
      },
    },
  ];

  return (
    <SFPageContainer disableGutters>
      <SFActionBar
        titleProps={{
          title: t("analyticsSkillExtractionRoutes.primaryText"),
        }}
        actionDefs={actionDefs}
        navDefs={navDefs}
      />
      <SFDatagrid
        canDownload={false}
        fitScreen
        columnDefs={columnDefs}
        gridName={GridNames.PRIMARY_TEXT}
        datasourceUrl={API_PARAM.PRIMARY_TEXT_GRID}
        filterValuesUrl={API_PARAM.PRIMARY_TEXT_COL_FILTER}
        basicFiltering
      />
    </SFPageContainer>
  );
};

export default PrimaryText;
